export const partsForm: any = {
  partNo: "",
  partName: "",
  description: "",
  models: [],
  entity: "",
};
